



















































/* Created- 20 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ContentStreamService, IContentStreamService } from "../../BusinessServices/contentstream";
import { ParticaEvent, getActionName, eParticaAction } from "../../Models/ParticaEvent";
import { StreamStatsDTO } from "../../Generated/ParticaAPI";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import ParticaCardXl from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaCardFill from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
import { ButtonType, ButtonStatus, ButtonConfig } from "../../Models/Buttons";
import { ParticaItem, ParticaSubItem, ParticaDropEvent, eParticaDragType } from "../../Models/ParticaItem";
import { ArrayUtils } from "../../BusinessServices/arrayutils";
import ParticaTree from "@/Ui-Components/Common/Tree/ParticaTree.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ContentStreamSubs from "../ContentStream/ContentStreamSubs.vue";

@Component(
	{
		name: "AdvancedStreamManagement",
		components: {
			ParticaView,
			ParticaCardXl,
			ParticaCardFill,
			ParticaTree,
			ParticaRightDrawer,
			ButtonList,
			ContentStreamSubs
		}
	})
export default class AdvancedStreamManagement extends ParticaAdminBase {
	private service: IContentStreamService;
	private data: StreamStatsDTO[] = [];
	private streams: ParticaItem[] = [];
	private drawer: boolean = false;
	private selected: ParticaSubItem = new ParticaSubItem();
	private subsdrawer: boolean = false;

	private buttons: ButtonConfig[] = [
		{
			label: "Delete Stream",
			action: eParticaAction.CONTENT_STREAM_DELETE_STREAM,
			type: ButtonType.Cancel,
			status: ButtonStatus.Enabled

		} as ButtonConfig,
		{
			label: "Go to Stream",
			action: eParticaAction.CONTENT_STREAM_SELECT_STREAM,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled

		} as ButtonConfig,
		{
			label: "Subscriptions",
			action: eParticaAction.CONTENT_STREAM_VIEW_SUBSCRIPTIONS,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled

		} as ButtonConfig
	];

	private getTitle(): string {
		return `Actions for '${this.selected.name}'`;
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_DELETE_STREAM: {
					await this.service.DeleteStream(parseInt(this.selected.id as string, 10));
					this.drawer = false;
					this.ShowSnackbar(`The stream '${this.selected.name}' has been removed.`);
					await this.init();
					this.ReloadMenu("");
					break;
				}

				case eParticaAction.CONTENT_STREAM_SELECT_STREAM: {
					this.navigate("contentstreamhome", { id: this.selected.id });
					break;
				}

				case eParticaAction.CONTENT_STREAM_VIEW_SUBSCRIPTIONS: {
					this.subsdrawer = true;
					break;
				}

				case eParticaAction.LEFT_MOUSE_CLICK: {
					this.selected = event.item as ParticaSubItem;
					this.drawer = true;
				}

				case eParticaAction.DRAG_MOVE_REQUEST: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.title = "Confirm moving stream.";
							this.dialog.message = `Move stream '${movedata.source.name}' to account '${movedata.destination.name}'?`;
							this.dialog.action = eParticaAction.DRAG_MOVE;
							this.dialog.item = movedata;
							this.dialog.show = true;
							break;
						}
						case eParticaDragType.many: {
							this.ShowSnackbar(`dragging multiple streams is not supported.`);
							break;
						}
						case eParticaDragType.all: {
							// check issue is not dropped on itself.
							// confirm you want to move all articles in issue to new issue.
							// if different pub then sections will be created if they do not exist.
							this.ShowSnackbar(`not implemented`);
							break;
						}
					}
					break;
				}
				case eParticaAction.DRAG_MOVE: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.show = false;
							await this.service.MoveStream(movedata.source.id, movedata.destination.id);
							await this.init();
							this.ReloadMenu("");
							break;
						}
						default: {
							this.ShowSnackbar("Not supported.");
						}
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Advanced Stream Management";
		this.service = this.particaServices.getContentStreamService();
		this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.data = await this.service.GetAllContentStreams();
			const ownergrp = ArrayUtils.groupBy(this.data, m => m.customerAccountId as number);
			this.streams = [];
			for (const key of Object.keys(ownergrp)) {
				const o: ParticaItem = new ParticaItem();
				o.id = key;
				const tmpstreams = ownergrp[key];
				tmpstreams.forEach(s => {
					if (s.customerAccountId !== undefined) {
						o.id = s.customerAccountId.toString();
						o.name = s.owner as string;
						const child: ParticaSubItem = new ParticaSubItem();
						child.name = s.name as string;
						if (s.streamId !== undefined) {
							child.id = s.streamId.toString();
						}
						child.parentid = key;
						o.children.push(child);
					}
				});
				this.streams.push(o);
			}
			await this.getAdminNav(0);

			// check if this account is listed.
			if (this.stateconfig.accountid > 0) {
				const thisaccounts: ParticaItem[] = this.streams.filter(s => s.id === this.stateconfig.accountid.toString());
				if (thisaccounts.length === 0) {
					const o: ParticaItem = new ParticaItem();
					if (this.navData.name !== undefined) {
						o.name = this.navData.name as string;
					}
					if (this.navData.id !== undefined) {
						o.id = this.navData.id.toString();
					}
					o.children = [];
					this.streams.push(o);
				}
			}

		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
